module.exports = __webpack_public_path__ + "img/icon_kexin@2x.d852596b.png";